export default class TicketApiDriveService {
  path ="api/me/tickets";
  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  /**
   * Liste des tickets pour une carte de fidélité pour un magasin
   */
  async tickets(params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(this.path, config);
    return res.data;
  }
  
  /**
   * Télécharger un ticket de caisse au format pdf
   */
  async ticketTelecharger(url) {
    const res = await this.httpApi.get(url);
    return res
  }

  /**
   * Consulter la préférence de reception des tickets
   * @param {Object} params
   */
  async preference(params) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/preference`, config);
    return res.data
  }

  /**
   * Mettre à jour les préférences de récéption de ticket
   * @param {Object} data
   */
  async preferenceChange(data) {
    const res = await this.httpApi.put(`${this.path}/preference`, data);
    return res.data;
  }
}
